import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { onboardingGuard } from './guards/onboarding.guard';
import { onboardingEntryGuard } from './guards/onboarding-entry.guard';
import { loginGuard } from './guards/login.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/landing/landing/landing.component').then(
        (c) => c.LandingComponent
      ),
  },
  {
    path: 'onboarding',
    loadComponent: () =>
      import('./components/onboarding/onboarding/onboarding.component').then(
        (c) => c.OnboardingComponent
      ),
    canActivate: [authGuard, onboardingEntryGuard],
  },
  {
    path: 'onboarding/select-type',
    loadComponent: () =>
      import('./components/onboarding/select-type/select-type.component').then(
        (c) => c.SelectTypeComponent
      ),
    canActivate: [onboardingEntryGuard],
  },
  {
    path: 'onboarding/create-fleet',
    loadComponent: () =>
      import('./components/onboarding/onboarding/onboarding.component').then(
        (c) => c.OnboardingComponent
      ),
    canActivate: [authGuard, onboardingEntryGuard],
  },
  {
    path: 'onboarding/join-fleet',
    loadComponent: () =>
      import('./components/onboarding/join-fleet/join-fleet.component').then(
        (c) => c.JoinFleetComponent
      ),
    canActivate: [authGuard, onboardingEntryGuard],
  },
  {
    path: 'payments',
    loadComponent: () =>
      import('./components/payments/payments/payments.component').then(
        (c) => c.PaymentsComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./components/dashboard/dashboard/dashboard.component').then(
        (c) => c.DashboardComponent
      ),
    canActivate: [authGuard, onboardingGuard],
  },
  {
    path: 'fleets',
    loadComponent: () =>
      import('./components/fleets/fleets/fleets.component').then(
        (c) => c.FleetsComponent
      ),
    canActivate: [authGuard, onboardingGuard],
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./components/reports/reports/reports.component').then(
        (c) => c.ReportsComponent
      ),
    canActivate: [authGuard, onboardingGuard],
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./components/settings/settings/settings.component').then(
        (c) => c.SettingsComponent
      ),
    canActivate: [authGuard, onboardingGuard],
  },
  {
    path: 'account',
    loadComponent: () =>
      import('./components/account/account/account.component').then(
        (c) => c.AccountComponent
      ),
    canActivate: [authGuard, onboardingGuard],
  },
  {
    path: 'tickets',
    loadComponent: () =>
      import('./components/tickets/tickets/tickets.component').then(
        (c) => c.TicketsComponent
      ),
    canActivate: [authGuard, onboardingGuard],
  },
  {
    path: 'cart',
    loadComponent: () =>
      import('./components/shopping-cart/shopping-cart.component').then(
        (c) => c.ShoppingCartComponent
      ),
    canActivate: [authGuard, onboardingGuard],
  },
  {
    path: 'vehicles',
    loadComponent: () =>
      import('./components/vehicles/vehicles/vehicles.component').then(
        (c) => c.VehiclesComponent
      ),
    canActivate: [authGuard, onboardingGuard],
  },
  {
    path: 'clients',
    canActivate: [authGuard, adminGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './components/clients/client-picker/client-picker.component'
          ).then((c) => c.ClientPickerComponent),
      },
      {
        path: ':client_id/users',
        loadComponent: () =>
          import(
            './components/clients/client-roster/client-roster.component'
          ).then((c) => c.ClientRosterComponent),
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./components/auth/login/login.component').then(
        (c) => c.LoginComponent
      ),
    canActivate: [loginGuard],
  },
  {
    // Public: the Terms and Conditions are readable without logging in (#958).
    path: 'terms',
    loadComponent: () =>
      import('./components/terms/terms/terms.component').then(
        (c) => c.TermsComponent
      ),
  },
  {
    path: 'callback',
    loadComponent: () =>
      import('./components/auth/callback/callback.component').then(
        (c) => c.CallbackComponent
      ),
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
